// const path = require('path');
// const fs = require('fs-extra');

const extend = require('extend');
const Q = require('q');
const _ = require('underscore');
// const moment = require('moment');
// const URI = require('urijs');

const OSS = require('ali-oss');

/**
 * NL类库
 *
 * @module nllib
 */

/**
 * 阿里云oss客户端（前端）
 *
 * <br>使用前执行：npm i ali-oss
 *
 * <br><a style="color:red;" href="https://help.aliyun.com/document_detail/32069.html?spm=5176.doc32074.6.737.tHfiQa" target="_blank">官方文档</a>
 * <br><a style="color:red;" href="https://github.com/ali-sdk/ali-oss" target="_blank">GitHub</a>
 *
 * @class nllib/src/system-docking/aliyun/oss/frontend/client
 * @constructor
 *
 * @param {object} pInitParameter
 * @param {string} pInitParameter.initType 初始化类型（100），默认值为100
 * @param {string} pInitParameter.initTypeParameter['100'].region 仅initType=100时有效，地区，默认值为oss-cn-shenzhen
 * <br>官方文档：https://help.aliyun.com/document_detail/31837.html?spm=5176.doc32070.2.6.2F7BQO
 *
 * @param {string} pInitParameter.initTypeParameter['100'].bucket 仅initType=100时有效，bucket，必须传入
 *
 * @param {function} pInitParameter.initTypeParameter['100'].getAuthInfo 仅initType=100时有效，获取授权信息
 * <br>1）返回值必须为一个延迟对象
 * <br>2）返回值解决的数据必须mixin以下格式的对象
 * <br>{accessKeyId:'', accessKeySecret:'', stsToken:''}
 *
 * @return {object} nllib/src/system-docking/aliyun/oss/frontend/client实例
 *
 */
module.exports = function (pInitParameter) {
    const __this = this;

    const defaultInitParameter = {};
    defaultInitParameter.initType = `100`;
    defaultInitParameter.initTypeParameter = {};
    defaultInitParameter.initTypeParameter[`100`] = {};
    defaultInitParameter.initTypeParameter[`100`].region = `oss-cn-shenzhen`;
    defaultInitParameter.initTypeParameter[`100`].bucket = ``;
    defaultInitParameter.initTypeParameter[`100`].getAuthInfo = function () {
        return Q.when({
            accessKeyId: `accessKeyId-not-found`,
            accessKeySecret: `accessKeySecret-not-found`,
            stsToken: `stsToken-not-found`,
        });
    };

    const initParameter = extend(true, {}, defaultInitParameter, pInitParameter);

    let __client;
    let __promise_initCompleted;
    const init = function () {
        const process_initType_100 = function () {
            const bucket = initParameter.initTypeParameter[`100`].bucket;
            if (!bucket) {
                console.error(`没有设置【bucket】参数！`);
                return Q.reject();
            }

            const getAuthInfo = initParameter.initTypeParameter[`100`].getAuthInfo;
            if (!_.isFunction(getAuthInfo)) {
                console.error(`没有实现【getAuthInfo】方法！`);
                return Q.reject();
            }

            __promise_initCompleted = Q.when()
                .then(function () {
                    return getAuthInfo();
                })
                .then(function (data) {
                    if (!data) {
                        console.error(`【getAuthInfo】返回的数据不合法！code:000`);
                        return Q.reject();
                    }
                    if (!data.accessKeyId) {
                        console.error(`【getAuthInfo】返回的数据不合法！code:200`);
                        return Q.reject();
                    }
                    if (!data.accessKeySecret) {
                        console.error(`【getAuthInfo】返回的数据不合法！code:300`);
                        return Q.reject();
                    }
                    if (!data.stsToken) {
                        console.error(`【getAuthInfo】返回的数据不合法！code:400`);
                        return Q.reject();
                    }

                    __client = new OSS({
                        region: initParameter.initTypeParameter[`100`].region,
                        accessKeyId: data.accessKeyId,
                        accessKeySecret: data.accessKeySecret,
                        stsToken: data.stsToken,
                        bucket: initParameter.initTypeParameter[`100`].bucket,
                    });
                })
            ;
        };

        switch (initParameter.initType) {
            case `100`:
                process_initType_100();
                break;
        }
    };
    init();

    const list = function (pParameter) {
        return __promise_initCompleted.then(function () {
            return __client.list(pParameter);
        });
    };

    const multipartUpload = function () {
        const __args = arguments;
        return Q.when()
            .then(function () {
                return __promise_initCompleted;
            })
            .then(function () {
                return __client.multipartUpload.apply(__client, Array.prototype.slice.call(__args));
            })
            .then(function (data) {
                if (!data) {
                    return Q.resolve(data);
                }

                if (data.url) {
                    return Q.resolve(data);
                }

                if (!data.res) {
                    return Q.resolve(data);
                }
                if (!data.res.requestUrls) {
                    return Q.resolve(data);
                }
                if (data.res.requestUrls.length <= 0) {
                    return Q.resolve(data);
                }

                const url_001 = decodeURI(data.res.requestUrls[0]);
                const url_002 = url_001.replace(/\?uploadId=.*/gi, ``);
                const url_http = url_002.replace(/https:\/\//gi, `http://`);
                const url_https = url_002.replace(/http:\/\//gi, `https://`);

                data.url = url_https;
                data.url_http = url_http;
                data.url_https = url_https;

                return Q.resolve(data);
            })
            .catch(function (ex) {
                console.error(ex);
                if (ex.stack) {
                    console.error(ex.stack);
                }
                return Q.reject(ex);
            })
            ;
    };

    /**
     * 查看所有文件
     * <br><a style="color:red;" href="https://help.aliyun.com/document_detail/32074.html?spm=5176.doc32070.6.742.2F7BQO" target="_blank">官方文档</a>
     * <div style="color:red;font-weight:bold;">version_number >= 2.0.0</div>
     *
     * @method list
     *
     * @param {object} pParameter 参考官方文档
     *
     * @return {object} promise
     *
     * @demo src/system-docking/aliyun/oss/frontend/client/demo/list.demo.js
     */
    __this.list = list;

    /**
     * 上传文件
     * <br><a style="color:red;" href="https://help.aliyun.com/document_detail/32072.html?spm=5176.doc32069.6.740.NGdDrj" target="_blank">官方文档</a>
     * <div style="color:red;font-weight:bold;">version_number >= 2.0.0</div>
     *
     * @method multipartUpload
     *
     * @param {arguments} ..args 参考<a style="color:red;" href="https://github.com/ali-sdk/ali-oss#multipartUpload" target="_blank">GitHub文档</a>
     *
     * @return {object} promise
     *
     * @demo src/system-docking/aliyun/oss/frontend/client/demo/multipartUpload.demo.js
     */
    __this.multipartUpload = multipartUpload;

};
